import React from 'react';
import { useHistory } from 'react-router-dom';
import backIcon from '../images/backIcon.svg';

function BackButton() {
  const { location: { pathname } } = useHistory();
  const history = useHistory();

  const returnButton = () => {
    if (pathname.includes('/foods')) {
      history.push('/foods');
    } else { history.push('/drinks'); }
  };

  return (
    <div>
      <button
        className="return-btn"
        onClick={ returnButton }
        type="button"
      >
        <img
          src={ backIcon }
          alt="BackButton recipe"
        />
      </button>
    </div>
  );
}

export default BackButton;
